<div class="routing-options">
  <app-modal-option-panel>
    <h3 panel-title>{{ languageService.languageJSON?.SettingsDialog_RoutingSettings }}</h3>

    <div class="routing-option-list modal-option-panel__stack">
      <div class="valuebox modal-setting-row">
        <div class="setting-text">
          <label id="routing-toll-label" for="routing-toll-switch">{{ languageService.languageJSON?.SettingsDialog_TollRoads }}</label>
          <p class="setting-description">{{ languageService.languageJSON?.SettingsDialog_TollRoads_Description }}</p>
        </div>
        <app-ev-switch class="value-switch" id="routing-toll-switch" aria-labelledby="routing-toll-label" [value]="tollRoad" (valueChange)="tollRoadChange.emit($event)"></app-ev-switch>
      </div>

      <div class="valuebox modal-setting-row">
        <div class="setting-text">
          <label id="routing-ferries-label" for="routing-ferries-switch">{{ languageService.languageJSON?.SettingsDialog_Ferries }}</label>
          <p class="setting-description">{{ languageService.languageJSON?.SettingsDialog_Ferries_Description }}</p>
        </div>
        <app-ev-switch class="value-switch" id="routing-ferries-switch" aria-labelledby="routing-ferries-label" [value]="ferries" (valueChange)="ferriesChange.emit($event)"></app-ev-switch>
      </div>

      <div class="valuebox modal-setting-row">
        <div class="setting-text">
          <label id="routing-highways-label" for="routing-highways-switch">{{ languageService.languageJSON?.SettingsDialog_Highways }}</label>
          <p class="setting-description">{{ languageService.languageJSON?.SettingsDialog_Highways_Description }}</p>
        </div>
        <app-ev-switch class="value-switch" id="routing-highways-switch" aria-labelledby="routing-highways-label" [value]="highways" (valueChange)="highwaysChange.emit($event)"></app-ev-switch>
      </div>
    </div>
  </app-modal-option-panel>

  <app-modal-option-panel>
    <h3 panel-title>{{ languageService.languageJSON?.SettingsDialog_TripSettings }}</h3>

    <div class="routing-option-list modal-option-panel__stack">
      <div class="valuebox modal-setting-row">
        <div class="setting-text">
          <label id="routing-trip-recording-label" for="routing-trip-recording-switch">{{ languageService.languageJSON?.CarSelectorDialog_Settings_TripRecording }}</label>
          <p class="setting-description">{{ languageService.languageJSON?.CarSelectorDialog_Settings_TripRecording_Description }}</p>
        </div>
        <app-ev-switch class="value-switch" id="routing-trip-recording-switch" aria-labelledby="routing-trip-recording-label" [value]="tripRecording" (valueChange)="tripRecordingChange.emit($event)"></app-ev-switch>
      </div>
    </div>
  </app-modal-option-panel>
</div>
